"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'MixBoard',
  props: {
    title: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: ''
    },
    itemData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isShowAop: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    color: function color() {
      if (this.theme === 'blue') {
        return 'rgb(0, 78, 168)';
      } else if (this.theme === 'yellow') {
        return '#FEDB00';
      } else if (this.theme === 'orange') {
        return '#FFBF60';
      } else {
        return '';
      }
    }
  },
  methods: {
    paddingNum: function paddingNum(inputParam) {
      return (0, _index.paddingNum)(inputParam);
    }
  }
};